"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const formatURLWithAddOnQueryParam_1 = __importDefault(require("../../../utils/http/formatURLWithAddOnQueryParam"));
/**
 * Client interface to get fleet quote data
 * @param {string} searchId
 * @param {number} groupId
 * @param {FleetQuoteReqParamType} reqParams
 * @returns Promise
 */
const getFleetQuote = (searchId, groupId, reqParams) => {
    const requestId = `FLEET_QUOTE_${Date.now()}`;
    const config = {};
    const rawEndpoint = ENDPOINTS_1.default.TARIFF_SERVICE.QUOTE_V2;
    const endPoint = rawEndpoint
        .replace('{searchId}', searchId)
        .replace('{groupId}', groupId.toString());
    const formattedEndPoint = (0, formatURLWithAddOnQueryParam_1.default)(endPoint, reqParams);
    return http_service_1.default
        .get(requestId, formattedEndPoint, config)
        .then((response) => response.data);
};
exports.default = getFleetQuote;
